module.exports = __webpack_public_path__ + "img/banner2.51f745fe.png";